// extracted by css-extract-rspack-plugin
export default {"goToTopBtn":"ScrollToTop__goToTopBtn--JxzDw","goToTopIcon":"ScrollToTop__goToTopIcon--SKRWJ"};